import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './i18n/i18n.module';
import AppRouter from './app/routes';
import store from './app/store';
import { Provider } from 'react-redux';
import { CookieConsent } from './components/cookie-consent';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root is missing');
}

const tree = (
  <React.StrictMode>
    <ChakraProvider>
      <Provider store={store}>
        <AppRouter />
        <CookieConsent />
      </Provider>
    </ChakraProvider>
  </React.StrictMode>
);

ReactDOM.createRoot(container).render(
  googleClientId ? (
    <GoogleOAuthProvider clientId={googleClientId}>{tree}</GoogleOAuthProvider>
  ) : (
    tree
  ),
);

reportWebVitals();
